import { Component, Input, OnInit } from '@angular/core';
import { DAO } from 'src/app/modal/DAO';
import { QuestionAnswer, Questionnaire } from 'src/app/modal/questionnaire.models';
import { ProductService } from 'src/app/services/product.service';
@Component({
  selector: 'app-municipal-tax',
  templateUrl: './municipal-tax.component.html',
  styleUrls: ['./municipal-tax.component.css']
})
export class MunicipalTaxComponent implements  OnInit{
  @Input() questionnaire: Questionnaire;
  @Input() isFormSubmitted: boolean;
  @Input() defaultDisable: boolean = false;
  @Input() name: string;
  public municipalLocation: QuestionAnswer; 
  public municipalLimit: QuestionAnswer; 

  constructor(public dao: DAO, public productService: ProductService) { }

  ngOnInit(): void {
    this.loadQuestionAnswers();
  }

  private loadQuestionAnswers(): void {
    var defaultQuestionAnswer = this.getDefaultQuestionAnswer();
    this.municipalLocation = this.LoadAnswerFromDefault('municipalLocation');
    this.municipalLimit = this.LoadAnswerFromDefault('municipalCityLimit');
  }

  public LoadAnswerFromDefault(key: string): QuestionAnswer {
        var defaultQuestionAnswer = this.getDefaultQuestionAnswer();
        let questionAnswer = this.questionnaire.questionAnswer.find(x => x.key === key) ?? defaultQuestionAnswer;
        if (!!!questionAnswer?.answer && questionAnswer?.questionDefault?.length > 0) {
            questionAnswer.answer = questionAnswer.questionDefault[0].code;
        }
        else if (!!!questionAnswer?.answer && questionAnswer?.questionDefault?.length == 0 
              && questionAnswer?.questionOptions[0]?.code.startsWith("CLICK")) 
        {
            questionAnswer.answer = questionAnswer?.questionOptions[0]?.code;
        }
        else if (!!questionAnswer?.answer && questionAnswer?.questionDefault?.length > 0 
                    && !!!questionAnswer?.questionOptions?.some(x => x.code == questionAnswer?.answer))
        {
             questionAnswer.answer = questionAnswer.questionDefault[0].code;
        }
        return questionAnswer;
  }

  public onValueChanged(): void {
    if (this.productService?.productModel?.productDetails?.municipalLocation) {
        this.productService.productModel.productDetails.municipalLocation.answer = this.municipalLocation.answer;
    }
    if (this.productService?.productModel?.productDetails?.municipalCityLimit) {
      this.productService.productModel.productDetails.municipalCityLimit.answer = this.municipalLimit.answer;
    }
  }

  private hasSelection(question: QuestionAnswer): boolean {
    return !!question?.answer && question?.answer !== 'CLICK';
  }

  private getDefaultQuestionAnswer(): QuestionAnswer {
    return {
        answer: null,
        enabled: false,
        required: false,
        group: null,
        hidden: false,
        key: null,
        isVehicleUpdatedbyVEH1: false,
        minimum: null,
        name: null,
        type: '',
        rowIndex: 0,
        questionOptions: []
    }
  }
}
